import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const RouteCheckInOrderIcon = (props) => {
  const {
    className,
    isValid,
  } = props;

  if (isValid !== false) {
    return null;
  }

  return (
    <i
      className={classnames(
        "RouteCheckInOrderIcon",
        "fa",
        "fa-random",
        "text-muted",
        className
      )}
      title="Check-ins are in wrong order" />
  );
};

RouteCheckInOrderIcon.propTypes = {
  className: PropTypes.string,
  isValid: PropTypes.bool,
};

export default RouteCheckInOrderIcon;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteCheckInOrderIcon.js
 **/